import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBInputText, LazyBSelect, LazyBSelectCard, LazyBTextarea, LazyLanguageSelector, LazyMFooter, LazyMHeader, LazyMobileNav, LazyPImage, LazyPLink, LazyPageHome, LazyRichText } from '#components'
const lazyGlobalComponents = [
  ["BInputText", LazyBInputText],
["BSelect", LazyBSelect],
["BSelectCard", LazyBSelectCard],
["BTextarea", LazyBTextarea],
["LanguageSelector", LazyLanguageSelector],
["MFooter", LazyMFooter],
["MHeader", LazyMHeader],
["MobileNav", LazyMobileNav],
["PImage", LazyPImage],
["PLink", LazyPLink],
["PageHome", LazyPageHome],
["RichText", LazyRichText],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
